module.exports = __webpack_public_path__ + "static/media/weight.b9300bbe.svg";